module.exports = __webpack_public_path__ + "img/20190806163239723.6aa3ac11.png";